import { render, staticRenderFns } from "./EditPassword.vue?vue&type=template&id=149ac78a&scoped=true"
import script from "./EditPassword.vue?vue&type=script&lang=js"
export * from "./EditPassword.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "149ac78a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian-bitbucket-pipelines-runner/74a6e498-56df-5c0c-aa3e-2f5fe39d1378/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('149ac78a')) {
      api.createRecord('149ac78a', component.options)
    } else {
      api.reload('149ac78a', component.options)
    }
    module.hot.accept("./EditPassword.vue?vue&type=template&id=149ac78a&scoped=true", function () {
      api.rerender('149ac78a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/Views/EditPassword.vue"
export default component.exports